export const ADDRESS_FORM_SUBMITTING = 'ADDRESS_FORM_SUBMITTING';
export const ADDRESS_FORM_SUCCESS = 'ADDRESS_FORM_SUCCESS';
export const ADDRESS_FORM_FAILED = 'ADDRESS_FORM_FAILED';
export const OPT_OUT_STARTED = 'OPT_OUT_STARTED';
export const OPT_OUT_SUCCESS = 'OPT_OUT_SUCCESS';
export const OPT_OUT_FAILED = 'OPT_OUT_FAILED';
